import * as React from "react";
import { useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";
import Popover from "@mui/material/Popover";
import Button from "@mui/material/Button";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import { useLocation } from "react-router-dom";
import { USER_ROLES, userRoles } from "../../staticData/userRoles";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";

function getNameForUrl({ pathName, userRole, disableDashboard }) {
  // switch (pathName) {
  if (pathName === "/event/new-requests") {
    return "Events > New Requests";
  } else if (pathName === "/event/new-request/details") {
    return isActiveRole(USER_ROLES.COORDINATOR)
      ? "Event > Details"
      : "Events > New Requests > Details";
  } else if (pathName === "/event/estimates") {
    return isActiveRole(USER_ROLES.CLIENT)
      ? "Events > Review Estimate"
      : isActiveRole(USER_ROLES.COORDINATOR)
        ? "Event > Details"
        : "Events > Estimates";
  } else if (pathName === "/event/estimates/view") {
    return isActiveRole(USER_ROLES.CLIENT)
      ? "Events > Review Estimate > Details"
      : "Events > Estimates > Details";
  } else if (pathName === "/event/all-events") {
    return "Events > Approved Events";
  } else if (pathName === "/event/partials") {
    return "Events > Saved Drafts";
  } else if (pathName === "/event/details") {
    return "All Events > Details";
  } else if (pathName === "/event/pre-book-contractors") {
    return "Events > Pre book contractors";
  } else if (pathName === "/positions") return "Positions";
  else if (pathName === "/requested-quote") return "Logistics Quote";
  else if (pathName === "/contractors") return "Contractors";
  else if (pathName === "/contractors/verify") return "Verify";
  else if (pathName === "/onboarding") return "Onboarding";
  else if (pathName === "/profile") return "Profile";
  else if (pathName === "/find-sow") return "SOW/PO";
  else if (pathName === "/media-gallery") return "Media Gallery";
  else if (pathName === "/users/admins") return "Users > Admins";
  else if (pathName === "/users/clients") return "Users > Clients";
  else if (pathName === "/users/coordinators") return "Users > Coordinators";
  else if (pathName === "/event/sow") return "SOW";
  else if (pathName === "/event/po") return "PO";
  else if (pathName === "/logs-of-event") return "Logs of Event";
  else if (pathName === "/dashboard") return "Dashboard";
  else if (pathName === "/generate-qr") return "Generate QR Code";
  else if (pathName === "/configuration/text-templates")
    return "Configuration > Text templates";
  else if (pathName === "/configuration/safety-and-non-harassment-videos")
    return "Configuration > Safety and harassment videos";
  else if (pathName === "/configuration/tutorial-video")
    return "Configuration > Tutorial Video";
  else if (pathName === "/configuration/airports")
    return "Configuration > Manage Airports";
  else if (pathName === "/configuration/contractor-links")
    return "Configuration > Onboarding Links";
  // contractors's routes
  else if (pathName === "/opportunities/not-responded" && !disableDashboard)
    return "Opportunities > Not Responded";
  else if (pathName === "/opportunities" && !disableDashboard)
    return "Opportunities";
  else if (pathName === "/opportunities/applied" && !disableDashboard)
    return "Opportunities > Applied";
  else if (pathName === "/schedule" && !disableDashboard) return "Schedule";
  else if (pathName === "/notifications" && !disableDashboard)
    return "Notifications";
  else if (pathName === "/resources" && !disableDashboard) return "Resources";
  else if (
    pathName === "/event/chat" &&
    ((userRole === userRoles.contractor && !disableDashboard) ||
      userRole !== userRoles.contractor)
  )
    return "Event > Chat";
  else if (
    pathName === "/event/chat/admin" &&
    ((userRole === userRoles.contractor && !disableDashboard) ||
      userRole !== userRoles.contractor)
  )
    return userRole !== "admin" && userRole !== "superAdmin"
      ? "Event > Admin Chat"
      : "Event > Clients Chat";
  else if (pathName === "/users/deleted") return "Users > Deleted";
  else if (pathName === "/contracts") return "Contracts";
  else if (pathName === "/contract-details") return "Contracts > Details";
  else if (pathName === "/contract/new") return "Contracts > New Contracts";
  else if (pathName === "/contract/under-review")
    return "Contracts > Under Review Contracts";
  else if (pathName === "/contract/verified")
    return "Contracts > Verified Contract";
  else if (pathName === "/reports/contractor-work")
    return "Reports > Contractor Work Report";
  else if (pathName === "/reports/assigned-by-users")
    return "Reports > Assigned By Users Report";
  else if (pathName === "/big-search") return "Big Search";
  else if (pathName === "/deposits") return "Deposit Invoices";
  else return "Navigate";
  // }
}

export default function MenuPopup({ children, sx, path, onClick }) {
  const isMinWidth1200px = useMediaQuery("(max-width: 1200px)");

  const auth = useSelector((store) => store.auth);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const lcoation = useLocation();
  const pathName = lcoation.pathname;

  const currentPathName = React.useMemo(
    () =>
      getNameForUrl({
        disableDashboard: auth?.disableDashboard,
        pathName,
        userRole: auth?.userRole,
      }),
    [pathName],
  );

  const handleClick = (event) => {
    if (onClick) {
      onClick();
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Box
      sx={{
        ...(sx || {}),
        "@media (min-width: 1200px)": {
          display: "none",
        },
      }}
    >
      <Button
        sx={{
          border: "2px solid #D175B6",
          background: "rgba(0, 0, 0, 0.50)",
          color: "#D175B6",
          "&:hover": {
            background: "rgba(0, 0, 0, 0.50)",
          },
        }}
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        endIcon={<KeyboardArrowDown />}
      >
        {path || currentPathName}
      </Button>
      {isMinWidth1200px ? (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          PaperProps={{
            style: {
              backgroundColor: "#000",
              borderRadius: "14px",
            },
            className: "custom-scroll-design",
          }}
          sx={{
            "@media (min-width: 1200px)": {
              display: "none",
            },
          }}
        >
          {children}
        </Popover>
      ) : null}
    </Box>
  );
}

MenuPopup.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
  path: PropTypes.string,
  onClick: PropTypes.func,
};
